import { render, staticRenderFns } from "./StepsPointer.vue?vue&type=template&id=98420b6c&"
import script from "./StepsPointer.vue?vue&type=script&lang=js&"
export * from "./StepsPointer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports